import { baseStudio } from './baseUrl';
import { STUDIO_ID_SUFFIX } from 'util/constants';

export const imagesPack = [
  {
    name: `Image 1${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}images/img1.jpg`,
    url: `${baseStudio}images/img1.jpg`,
  },
  {
    name: `Image 2${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}images/img2.jpg`,
    url: `${baseStudio}images/img2.jpg`,
  },
  {
    name: `Image 3${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}images/img3.jpg`,
    url: `${baseStudio}images/img3.jpg`,
  },
  {
    name: `Image 4${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}images/img4.jpg`,
    url: `${baseStudio}images/img4.jpg`,
  },
  {
    name: `Image 5${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}images/img5.jpg`,
    url: `${baseStudio}images/img5.jpg`,
  },
  {
    name: `Image 6${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}images/img6.jpg`,
    url: `${baseStudio}images/img6.jpg`,
  },
  {
    name: `Image 7${STUDIO_ID_SUFFIX}`,
    thumbnail: `${baseStudio}images/img7.jpg`,
    url: `${baseStudio}images/img7.jpg`,
  },
];
